import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getItemOfSessionStorage, setItem } from '../../services/common/utils';
import { SELECTED_LANG } from '../../services/common/Constants';
import { resetUserData } from '../../reducer/actions';
import { resetCdrReduxData } from '../../reducer/cdrSlice';

const pagesNotToBeConsidered = [
  '#/paybill',
  '#/recharge',
  '#/moremenu',
  '#/recharge',
  '#/requestcredit',
  '#/payviavoucher',
];

function TockenCheck() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tokenid = useSelector((state) => state?.userdata?.value?.tokenid) || sessionStorage.getItem('authkey');

  useEffect(() => {
    if (tokenid) {
      tokenDetailsApi.refetch();
    }
    //eslint-disable-next-line
  }, [window?.location?.hash, tokenid]);

  const clearData = () => {
    let _lang = getItemOfSessionStorage(SELECTED_LANG);
    dispatch(resetUserData());
    dispatch(resetCdrReduxData());
    sessionStorage.clear();
    try {
      var _savedLogin = localStorage.getItem('sl');
      localStorage.clear();
      if (
        _savedLogin != null &&
        _savedLogin != undefined &&
        _savedLogin != '' &&
        _savedLogin != 'undefined'
      ) {
        localStorage.setItem('sl', _savedLogin);
      }
    } catch {}
    setItem(SELECTED_LANG, _lang);
  };

  const tokenDetailsApi = useQuery(
    [
      'tokenDetailsApi',
      'ApiFeatures/checktoken',
      { tokenid: "" },
      {},
    ],
    {
      retry: false,
      retryOnMount: true,
      cacheTime: 0,
      staleTime: 0,
      enabled: false,
      onSuccess: ({ data }) => {
        // if valid token - no changes
        if (data?.status === '0') {

        // else clear data and ...
        } else {
          clearData();

          // if pages are in pagesNotToBeConsidered
          if (pagesNotToBeConsidered.includes(window.location.hash)) {
          
          // navigate to '/' 
          } else {
            navigate('/');
          }
        }
      },
    }
  );

  if (tokenDetailsApi.isLoading || tokenDetailsApi.isFetching) {
    return <></>;
  }

  return <></>;
}

export default TockenCheck;
